module.exports = __webpack_public_path__ + "static/img/mission.004dd16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/mission.png
// module id = SRmb
// module chunks = 0